module.exports = __webpack_public_path__ + "img/chart-flowers-1-2x.55ee9b58.png";